var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletswap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8925 11.5625H3.63773C3.5476 11.5625 3.47386 11.6328 3.47386 11.7188V12.8906C3.47386 12.9766 3.5476 13.0469 3.63773 13.0469H16.0346L13.0788 16.6211C12.9948 16.7227 13.0706 16.875 13.2078 16.875H14.6929C14.7933 16.875 14.8875 16.832 14.951 16.7559L18.4087 12.5742C18.7467 12.1641 18.4415 11.5625 17.8925 11.5625ZM18.3862 6.95312H5.98929L8.94513 3.37891C9.02911 3.27734 8.95332 3.125 8.81608 3.125H7.33099C7.23062 3.125 7.13639 3.16797 7.07289 3.24414L3.6152 7.42578C3.27721 7.83594 3.58242 8.4375 4.12934 8.4375H18.3862C18.4763 8.4375 18.5501 8.36719 18.5501 8.28125V7.10938C18.5501 7.02344 18.4763 6.95312 18.3862 6.95312Z",
    fill: "#B4C9F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletswap);
export default __webpack_public_path__ + "static/media/walletswap.eb0b6669fd621398f11a95f8c8e3723f.svg";
export { ForwardRef as ReactComponent };